import { Box, Divider } from '@mui/material';
import useBlendableImage from '~/hooks/image/useBlendableImage';
import usePrimaryImage from '~/hooks/image/usePrimaryImage';
import BlendImage from './BlendImage';
import ImageBlending from './ImageBlending';
import PrimaryImage from './PrimaryImage';

export default function Images() {
    const { primaryImage, availableImages, handleChangePrimaryImage } =
        usePrimaryImage(true);
    const { blendedImage, blendableImages, handleChangeBlendedImage } =
        useBlendableImage();
    return (
        <Box>
            {primaryImage && (
                <>
                    <Divider />
                    <Box
                        display="flex"
                        flexDirection={'column'}
                        mt={2}
                        gap={blendedImage && 2}
                        mr={blendedImage && 2}
                        position="relative"
                    >
                        <PrimaryImage
                            image={primaryImage}
                            onChange={handleChangePrimaryImage}
                            availableImages={availableImages}
                        />
                        {blendedImage && (
                            <BlendImage
                                image={blendedImage}
                                onChange={handleChangeBlendedImage}
                                blendableImages={blendableImages}
                            />
                        )}
                        <ImageBlending />
                    </Box>
                </>
            )}
        </Box>
    );
}
